module.exports = __webpack_public_path__ + "img/chevron-3.af7d927e.jpg";